import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { CompetitionStatusEnum } from '@flipster/apis/v2/trading-competition/types';

import { competitionApiBunja } from '../state';
import { Champions } from './champions';
import { EventTitle } from './event-title';
import { LastChampions } from './last-champions';
import { Leaderboard } from './leaderboard';
import { Milestone } from './milestone';
import { RankingReward } from './ranking-reward';
import { Rules } from './rules';

export const VolumePnl = () => {
  const { competitionStatusAtom } = useBunja(competitionApiBunja);
  const competitionStatus = useAtomValue(competitionStatusAtom);

  if (competitionStatus === CompetitionStatusEnum.Ongoing) return <DuringVolumePNLContent />;
  if (competitionStatus === CompetitionStatusEnum.Finished) return <AfterVolumePNLContent />;
  return <BeforeVolumePNLContent />;
};

const BeforeVolumePNLContent = () => {
  return (
    <>
      <EventTitle />
      <RankingReward />
      <Milestone />
      <Rules />
      <LastChampions />
    </>
  );
};

const DuringVolumePNLContent = () => {
  return (
    <>
      <EventTitle />
      <Milestone />
      <Leaderboard />
      <Rules />
      <RankingReward hasTitle />
    </>
  );
};

const AfterVolumePNLContent = () => {
  return (
    <>
      <Champions />
      <Milestone />
      <Leaderboard />
      <Rules />
    </>
  );
};
